// Cart Treats Upsell — Subscribe-aware (Option 1: same plan for both, validated + debug)
document.addEventListener('DOMContentLoaded', function () {
  const cartUpsellSection = document.getElementById('cartTreatsUpsell');
  const addBothBtn  = document.getElementById('cartAddBothTreats');
  const dismissBtn  = document.getElementById('cartDismissOffer');
  const bundleForm  = document.getElementById('cartBundleForm');

  // Hidden inputs for bundle
  const bundleItem1 = document.getElementById('cartBundleItem1');
  const bundleItem2 = document.getElementById('cartBundleItem2');
  const bundlePlan1 = document.getElementById('cartBundlePlan1');
  const bundlePlan2 = document.getElementById('cartBundlePlan2');

  // Subscribe UI
  const subToggle   = document.getElementById('cartTreatsSubscribeToggle');
  const freqWrap    = document.getElementById('cartTreatsFrequency');
  const planSelect  = document.getElementById('cartTreatsPlanSelect');

  // Show whenever there are no treats in cart and we have at least two treats to offer
  const MINIMUM_CART_TOTAL = 0;
  let availableTreats = [];

  // Helper: extract selling plan IDs from a treat object
  const getTreatPlans = treat =>
    Array.isArray(treat?.sellingPlans) ? treat.sellingPlans.map(p => String(p.id)) : [];

  // Helper: find common selling plans between two treats
  const getSharedPlans = (t1, t2) => {
    const plans1 = getTreatPlans(t1);
    const plans2 = getTreatPlans(t2);
    return plans1.filter(id => plans2.includes(id));
  };

  // -------- UI helpers
  const show = el => { if (el) el.style.display = ''; };
  const hide = el => { if (el) el.style.display = 'none'; };

  function syncSubscribeUI() {
    const hasPlans = !!(planSelect && planSelect.options.length);
    if (!subToggle) return;
    if (subToggle.checked && hasPlans) {
      show(freqWrap);
      if (!planSelect.value) planSelect.value = planSelect.options[0].value;
    } else {
      hide(freqWrap);
    }
  }

  // -------- init treats + prefill toggle/plan
  function initializeTreats() {
    const data = window.cartTreatsData || {};
    availableTreats = Array.isArray(data.treats) ? data.treats : [];

    console.log('📦 Treat data from Liquid:', availableTreats);

    if (subToggle) subToggle.checked = !!data.hasSubscriptionInCart;

    if (planSelect && data.cartSellingPlanId) {
      [...planSelect.options].forEach(opt => {
        if (String(opt.value) === String(data.cartSellingPlanId)) opt.selected = true;
      });
    }

    syncSubscribeUI();
  }

  // -------- show/hide logic
  function checkCartTotal() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price / 100;
        const hasTreatInCart = Array.isArray(cart.items) && cart.items.some(it => {
          try { return String(it.product_title || '').toLowerCase().includes('treat'); } catch { return false; }
        });

        if (!hasTreatInCart && availableTreats.length >= 2 && total >= MINIMUM_CART_TOTAL) {
          showUpsell();
        } else {
          hideUpsell();
        }
      })
      .catch(() => {
        // Network issue: fall back to showing only if we have data and let user decide
        if (availableTreats.length >= 2) showUpsell();
      });
  }

  function showUpsell() {
    if (!cartUpsellSection) return;
    cartUpsellSection.style.display = 'block';
    cartUpsellSection.style.opacity = '0';
    cartUpsellSection.style.transform = 'translateY(20px)';
    requestAnimationFrame(() => {
      cartUpsellSection.style.transition = 'all .5s ease';
      cartUpsellSection.style.opacity = '1';
      cartUpsellSection.style.transform = 'translateY(0)';
    });
  }

  function hideUpsell() {
    if (!cartUpsellSection) return;
    cartUpsellSection.style.opacity = '0';
    cartUpsellSection.style.transform = 'translateY(-20px)';
    setTimeout(() => { cartUpsellSection.style.display = 'none'; }, 500);
  }

  // -------- add bundle (validate shared plan)
  function addTreatsBundle() {
    if (!bundleForm || availableTreats.length < 2) return;
    if (addBothBtn?.classList.contains('loading')) return;

    // Debug: Log plan IDs for both treats
    console.log('🛠 Treat 1 plans:', getTreatPlans(availableTreats[0]));
    console.log('🛠 Treat 2 plans:', getTreatPlans(availableTreats[1]));

    addBothBtn?.classList.add('loading');
    addBothBtn.disabled = true;
    addBothBtn.textContent = 'Adding to Cart...';

    // Variant IDs
    bundleItem1.value = availableTreats[0].variantId;
    bundleItem2.value = availableTreats[1].variantId;

    // Reset plans first
    bundlePlan1.value = '';
    bundlePlan2.value = '';

    if (subToggle?.checked) {
      const sharedPlans = getSharedPlans(availableTreats[0], availableTreats[1]);
      console.log('🔍 Shared plans:', sharedPlans);

      if (sharedPlans.length === 0) {
        console.warn('⚠ No shared selling plan found — defaulting to one-time purchase');
      }

      const cartPlanId = String(window.cartTreatsData?.cartSellingPlanId || '');
      const selectedPlanId = String(planSelect?.value || '');

      let chosenPlan = '';
      if (cartPlanId && sharedPlans.includes(cartPlanId)) {
        chosenPlan = cartPlanId;
      } else if (selectedPlanId && sharedPlans.includes(selectedPlanId)) {
        chosenPlan = selectedPlanId;
      } else if (sharedPlans.length > 0) {
        chosenPlan = sharedPlans[0];
      }

      if (chosenPlan) {
        bundlePlan1.value = chosenPlan;
        bundlePlan2.value = chosenPlan;
      }
    }

    console.log('🧺 Adding bundle', {
      item1: bundleItem1.value,
      item2: bundleItem2.value,
      plan1: bundlePlan1.value || '(one-time)',
      plan2: bundlePlan2.value || '(one-time)'
    });

    bundleForm.submit();
  }

  // -------- events
  const cartOpenBundlePopupBtn = document.getElementById('cartOpenBundlePopup');
  if (cartOpenBundlePopupBtn) {
    cartOpenBundlePopupBtn.addEventListener('click', function(e) {
      e.preventDefault();
      // Wait for treats-bundle.js to initialize, then open popup
      if (window.openBundlePopup) {
        window.openBundlePopup(null, 'mixed');
      } else {
        // Fallback: wait a bit for script to load
        setTimeout(() => {
          if (window.openBundlePopup) {
            window.openBundlePopup(null, 'mixed');
          } else {
            // Final fallback: use old method
            addTreatsBundle();
          }
        }, 500);
      }
    });
  }
  
  addBothBtn?.addEventListener('click', addTreatsBundle);
  dismissBtn?.addEventListener('click', hideUpsell);
  subToggle?.addEventListener('change', syncSubscribeUI);
  planSelect?.addEventListener('change', syncSubscribeUI);

  // -------- boot
  initializeTreats();
  setTimeout(checkCartTotal, 400);
  setTimeout(checkCartTotal, 1800);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) checkCartTotal(); });

  window.testUpsell = () => { initializeTreats(); showUpsell(); };
});
